export const ApplicationName = 'BVGer.Foren.WebClient';

// Storage keys
export const StorageKeys = {
  AccessToken: 'accessToken',
  TokenExpiry: 'tokenExpiry',
  User: 'user',
} as const;

// Auth-related paths
export const AuthPaths = {
  // Razor Pages login (server-side)
  Login: '/Identity/Account/Login',
  // Home page after logout
  Home: '/',
  // SPA routes
  DefaultRedirect: '/foren',
} as const;

// API endpoints
export const AuthEndpoints = {
  Token: '/api/auth/token',
  Check: '/api/auth/check',
  Me: '/api/auth/me',
  Logout: '/api/auth/logout',
} as const;
